import React from 'react';

import { useTranslation } from 'react-i18next';

import AdminService from '../../../../../services/AdminService';
import TableView from '../../TableView';

export default function Languages({ setItemCount }) {
  const { t } = useTranslation();

  const columns = [
    {
      name: t(
        'dashboardComponents.Console.RefDataManagement.Languages.languageName'
      ),
      field: 'name',
      sortable: true,
    },
    { name: t('common.sortOrder'), field: 'sortOrder', sortable: true },
    {
      name: t('common.notes'),
      field: 'note',
      sortable: false,
    },
    {
      name: t('common.createdOn'),
      field: 'createdAt',
      sortable: true,
      type: 'date',
    },
  ];

  return (
    <TableView
      setItemCount={setItemCount}
      dataName="Language"
      getDataHandler={AdminService.getLanguages}
      deleteDataHandler={AdminService.deleteLanguage}
      createDataHandler={AdminService.createLanguage}
      updateDataHandler={AdminService.updateLanguage}
      viewLeftColumnFields={[{ label: 'Name', field: 'name' }]}
      viewRightColumnFields={[
        { label: t('common.sortOrder'), field: 'sortOrder' },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
        },
      ]}
      formLeftColumnFields={[
        {
          label: 'Name',
          field: 'name',
          validation: ['string', 'required'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.Languages.languageNameHere'
          ),
        },
      ]}
      formRightColumnFields={[
        {
          label: t('common.sortOrder'),
          field: 'sortOrder',
          validation: ['string', 'required', 'numbers'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.Languages.specifySortOrderHere'
          ),
          maxLength: 5,
        },
        {
          label: t('common.notes'),
          field: 'note',
          type: 'textarea',
          validation: ['string'],
          placeholder: t(
            'dashboardComponents.Console.RefDataManagement.Languages.enterAnySpecificNotesAboutTheLanguage'
          ),
        },
      ]}
      columns={columns}
    />
  );
}
